import { render, staticRenderFns } from "./admin-person-info.vue?vue&type=template&id=2622e1b8&"
import script from "./admin-person-info.vue?vue&type=script&lang=js&"
export * from "./admin-person-info.vue?vue&type=script&lang=js&"
import style0 from "./admin-person-info.vue?vue&type=style&index=0&id=2622e1b8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports